export class Gallery {
  galleryId: string;
  title: string;
  show: boolean;
  thumbnailUrl: string;
  imageUrls: string[]
}